<template>
    <div class="mx-5">
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form name="formConyuge" @submit.prevent="enviarDatos">
                <v-card flat>
                    <v-row>
                        <v-col :class="($vuetify.breakpoint.mobile) ? 'my-2' : 'my-5'">
                            <div class="font-weight-bold text-body-1 black--text text-uppercase">
                                {{ titulo1 }}
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                <v-text-field dense v-model="itemDataSelected.nombres"
                                    @input="itemDataSelected.nombres = itemDataSelected.nombres.toUpperCase()"
                                    :error-messages="v.errors[0]" label="Nombres">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                <v-text-field dense v-model="itemDataSelected.apellido"
                                    @input="itemDataSelected.apellido = itemDataSelected.apellido.toUpperCase()"
                                    :error-messages="v.errors[0]" label="Apellido">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <ValidationProvider rules="required|minmax:7,8|numeric" v-slot="v">
                                <v-text-field dense v-model="itemDataSelected.nrodoc" @keydown="preventArrowKeys"
                                    type="number" hide-spin-buttons label="DNI Nro." :error-messages="v.errors[0]">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="2">
                            <ValidationProvider rules="required" v-slot="v">
                                <v-select dense v-model="itemDataSelected.sexo" :items="itemSexo" label="Sexo"
                                    item-value="item" item-text="item" :error-messages="v.errors[0]"></v-select>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|max:10|menoranios" v-slot="v">
                                <v-text-field v-model="itemDataSelected.fecnacim" dense label="Fecha de nacimiento:"
                                    type="date" :error-messages="v.errors[0]"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <ValidationProvider rules="required" v-slot="v">
                                <v-autocomplete dense v-model="itemDataSelected.nacionalidad"
                                    @input="selectNacionalidad" return-object :items="nacionalidades" item-value="id"
                                    item-text="desnacionalidad" label="Nacionalidad" :error-messages="v.errors[0]">
                                </v-autocomplete>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="4">
                            <ValidationProvider rules="required" v-slot="v">
                                <v-autocomplete dense v-model="itemDataSelected.tipnacionalidad"
                                    :error-messages="v.errors[0]" @input="selectTipNacionalidad"
                                    :items="tipoNacionalidad" item-value="tna_id" return-object
                                    item-text="tna_destipnac" label="Tipo de nacionalidad">
                                </v-autocomplete>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="datosPersonales.fecestadocivil" dense readonly
                                label="Fecha de estado civil:" type="date"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider class="my-5"></v-divider>
                    <v-row>
                        <v-card-text class="font-weight-bold text-body-1 black--text text-uppercase">
                            <!-- Documentación requerida de tu conyuge/conviviente -->
                            {{ titulo2 }}
                        </v-card-text>
                    </v-row>
                    <v-row class="d-flex justify-space-around align-end">
                        <InputButtonArchivo op="dniFrenteFamiliar" label="DNI FRENTE"
                            @fileSelected="handleFileSelected">
                        </InputButtonArchivo>
                        <InputButtonArchivo op="dniDorsoFamiliar" label="DNI DORSO" @fileSelected="handleFileSelected">
                        </InputButtonArchivo>
                        <InputButtonArchivo op="certMatConConvFamiliar"
                            :label="(datosPersonales.estadocivil == 2) ? 'ACTA DE MATRIMONIO' : 'ACTA DE CONVIVENCIA'"
                            @fileSelected="handleFileSelected">
                        </InputButtonArchivo>
                        <!--         <v-col v-if="(estaFallecido)" :cols="(estaFallecido) ? '6' : '12'" :md="mdCalculado">
                            <InputButtonArchivo op="certDefuncionFamiliar" label="CERT. DEFUNCIÓN"
                                @fileSelected="handleFileSelected">
                            </InputButtonArchivo>
                        </v-col> -->
                    </v-row>
                    <v-divider class="my-5"></v-divider>
                    <div class="d-flex justify-space-between form-footer" @click="forzarValidacion">
                        <v-btn color="secondary" outlined elevation="0" @click="volver" class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-left</v-icon>atras
                        </v-btn>
                        <v-btn color="primary" elevation="0" type="submit" :disabled="invalid || !formValid"
                            class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-right</v-icon>siguiente
                        </v-btn>
                    </div>
                </v-card>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import InputButtonDniDorso from '@/components/inputs/InputButtonDniDorso.vue'
import InputButtonDniFrente from '@/components/inputs/InputButtonDniFrente.vue'
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue'
import InputBtnArchivo from '@/components/inputs/InputBtnArchivo.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "form-conyuge-afi",
    components:
    {
        ValidationProvider,
        ValidationObserver,
        InputButtonDniFrente,
        InputButtonDniDorso,
        InputButtonArchivo,
        InputBtnArchivo,
    },
    watch: {
        'itemDataSelected.discapacidad'(newValue) {
            this.itemDataSelected.discapacidad = newValue
        },
        'itemDataSelected.estadocivil'() {
            this.itemDataSelected.estadocivil = this.datosPersonales.estadocivil
        }
    },
    data() {
        return {
            //nuevo
            itemDataSelected: {
                nombres: '',
                apellido: '',
                tipdoc: 'DNI',
                nrodoc: '',
                sexo: '',
                fecnacim: '',
                fecestadocivil: '',
                estadocivil: '',
                nacionalidad: 1,
                desnacionalidad: '',
                tipnacionalidad: 1,
                destipnacionalidad: '',
                tipfamiliar: '',
                destipfamiliar: '',
                fecfallecido: '',
                fallecido: '',
                discapacidad: 'N',
            },
            /*             itemDataSelected: {
                            nombres: '',
                            apellido: '',
                            tipdoc: '',
                            nrodoc: '',
                            sexo: '',
                            fecnacim: '',
                            fecestadocivil: '',
                            estadocivil: '',
                            nacionalidad: '',
                            desnacionalidad: '',
                            tipnacionalidad: '',
                            destipnacionalidad: '',
                            tipfamiliar: '',
                            destipfamiliar: '',
                            fecfallecido: '',
                            fallecido: '',
                            discapacidad: 'N',
                        }, */

            itemTipDni: ['DNI', 'CI', 'LE', 'LC', 'PAS'], // item select tipo de dni
            itemSexo: ['F', 'M', 'X'], // item select sexo
            valid: false,
            overlay: true,
            showBtn: false,

            discConyuge:
                [
                    { text: 'Si', value: 'S' },
                    { text: 'No', value: 'N' },
                ],

            formValid: false,

            titulo: '',
            tipo: ''
        }

    },
    mounted() {

    },
    computed: {
        ...mapGetters('common', ['nacionalidades', 'estadoCivil', 'tipoNacionalidad']),
        ...mapGetters('preafiliacion', ['dniFrenteFamiliar', 'dniDorsoFamiliar', 'certDiscFamiliar', 'certDefuncionFamiliar', 'certMatConConvFamiliar',
            'datosPersonales']),

        mdCalculado() {
            if ((!this.esDiscapacitado) && (!this.estaFallecido)) return '4'
            else if (this.esDiscapacitado) return '3'
        },
        esDiscapacitado() {
            return (this.itemDataSelected.discapacidad == 'S')
        },
        estaFallecido() {
            return (this.datosPersonales.estadocivil == 7)
        },
        cargaDni() {
            return !((this.datosPersonales.estadocivil == 7) || (this.datosPersonales.estadocivil == 5) || (this.datosPersonales.estadocivil == 4))
        },
        esDivorciado() {
            return (this.datosPersonales.estadocivil == 5) || (this.datosPersonales.estadocivil == 4)
        },
        esCasado() {
            return (this.datosPersonales.estadocivil == 2)
        },
        parentesco() {
            if (this.datosPersonales.estadocivil == 2) this.itemDataSelected.tipfamiliar = 1
            else if ((this.datosPersonales.estadocivil == 6) || (this.datosPersonales.estadocivil == 7)) this.itemDataSelected.tipfamiliar = 2
        },
        titulo1() {
            if (this.datosPersonales.estadocivil == 2) return 'Datos de tu cónyuge'
            else return 'Datos de tu conviviente'
        },
        titulo2() {
            if (this.datosPersonales.estadocivil == 2) return 'Documentación requerida de tu cónyuge'
            else return 'Documentación requerida de tu conviviente'
        }
    },
    methods: {
        ...mapActions('common', ['getTiposFamiliares']),
        ...mapActions('preafiliacion', ['addFilesPre', 'deleteFilesPre', 'deleteItemPre', 'guardarDatosConyuge']),

        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },

        handleFileSelected() {
            if (this.cargaDni) {
                if (!this.esDiscapacitado)
                    (this.dniFrenteFamiliar.length != 0) && (this.dniDorsoFamiliar.length != 0) && (this.certMatConConvFamiliar.length != 0) ? this.formValid = true : this.formValid = false
                else
                    (this.dniFrenteFamiliar.length != 0) && (this.dniDorsoFamiliar.length != 0) && (this.certDiscFamiliar.length != 0) && (this.certMatConConvFamiliar.length != 0) ? this.formValid = true : this.formValid = false
            } else if (this.estaFallecido) {
                (this.certMatConConvFamiliar.length != 0) && (this.certDefuncionFamiliar.length != 0) ? this.formValid = true : this.formValid = false
            }
            else {
                if (!this.esDiscapacitado)
                    (this.certMatConConvFamiliar.length != 0) ? this.formValid = true : this.formValid = false
                else
                    (this.certMatConConvFamiliar.length != 0) && (this.certDiscFamiliar.length != 0) ? this.formValid = true : this.formValid = false
            }
        },
        volver() {
            this.$emit('atras')
        },
        selectTipNacionalidad(value) {
            this.itemDataSelected.tipnacionalidad = value.tna_id
            this.itemDataSelected.destipnacionalidad = value.tna_destipnac
        },
        selectNacionalidad(value) {
            this.itemDataSelected.nacionalidad = value.id
            this.itemDataSelected.desnacionalidad = value.desnacionalidad
        },
        onClearFileInput() {
            this.deleteFilesPre({ file: '', op: this.op })
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        enviarDatos() {
            //guardado de datos en store
            this.itemDataSelected.fecestadocivil = this.datosPersonales.fecestadocivil
            this.itemDataSelected.estadocivil = this.datosPersonales.estadocivil
            this.itemDataSelected.tipfamiliar = (this.itemDataSelected.estadocivil == 11 || this.itemDataSelected.estadocivil == 9) ? 2 : 1
            this.$refs.obs.validate().then(result => {
                if (result) {
                    // Agarra los datos del form y los almacena un un
                    // nuevo formData
                    this.guardarDatosConyuge(this.itemDataSelected)
                    this.$emit('siguiente')
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                    this.showSnack({
                        type: '400',
                        message: 'Formulario invalido, revise los campos.'
                    })
                }
            });
        },

    },
    props: ['loading', 'index']

}

</script>

<style scoped>
.btn-fade-in-out {
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
}

.btn-fade-in-out:hover {
    opacity: 1;
}
</style>
